// Availability describes the marketing journey, not contracted clinical coverage.
// Claim IDs refer to docs/project-staging/claims-register.md.
export const workflows = [
  {
    id: 'telemedicine',
    title: 'SeaScope Telemedicine',
    path: '/telemedicine',
    audience: 'Fleet operators and shipboard officers',
    steps: ['Officer records a case', 'Authorized shore team responds', 'Clinician signs advice', 'Team follows up'],
    availability: 'available',
    evidenceRef: 'src/pages/Telemedicine.jsx; C01-C04; Q02 clinical role and response qualification pending',
  },
  {
    id: 'peme-review',
    title: 'SeaScope PEME Review',
    path: '/peme/review',
    audience: 'Fleet operators and commissioned reviewers',
    steps: ['Receive completed examination documents', 'Check scheme requirements and evidence', 'Clinician reviews', 'Record disposition'],
    availability: 'available',
    evidenceRef: 'src/pages/PemeReview.jsx; C05-C07; W05–W08 staging lifecycle qualification pending',
  },
  {
    id: 'peme-examination',
    title: 'SeaScope PEME Examination',
    path: '/peme/examinations',
    audience: 'PEME clinics, agencies, and seafarers',
    steps: ['Crew intake or agency enrolment', 'Form A or supported paper route', 'Clinician examination and Form B', 'Examiner attestation and certificate'],
    availability: 'preview',
    evidenceRef: 'src/pages/PemeExaminations.jsx; C17; W01–W08 and Q02 staging lifecycle qualification pending',
  },
  {
    id: 'crew-wellness',
    title: 'Crew Wellness',
    path: '/wellness',
    audience: 'Seafarers and authorized care teams',
    steps: ['Join the separate wellness journey', 'Record readings', 'Authorized clinician reviews trends'],
    availability: 'available',
    evidenceRef: 'src/pages/Wellness.jsx; C12; W08/Q02 access and data-scope qualification pending',
  },
  {
    id: 'individual-cds',
    title: 'SeaScope CDS',
    path: '/seascope-cds',
    audience: 'Individual clinicians',
    steps: ['Open individual offering', 'Use clinician decision support', 'Document encounter'],
    availability: 'preview',
    evidenceRef: 'src/pages/PhysicianCds.jsx; src/pages/Pricing.jsx#physicians; C16; Q02 capability qualification pending',
  },
];
